import aiChatbotImportPptxPdf from './ai-chatbot-import-pptx-pdf.module'
import aiInsights from './ai-insights.module'

export default {
  aiChatbotImportPptxPdf,
  aiInsights,
}
